<template>
	<div>
		<v-row>
			<v-col cols="12">
				<div class="form-base__title">
					Реквизиты документа, подтверждающего должность или статус
					представителя
				</div>
				<div class="form-base__tooltip">
					<v-icon small>{{ mdiAlertCircleOutline }}</v-icon>
					<span class="text">
            Например, устав, приказ о назначении на должность, удостоверение
            адвоката и другие документы
          </span>
				</div>
			</v-col>

			<v-col cols="9">
				<v-text-field
					v-model="v.name.$model"
					:errorMessages="getValidationErrorText(v.name)"
					label="Наименование документа"
					outlined
				/>
			</v-col>
			<v-col cols="3">
				<DateFieldCustom
					label="Дата выдачи"
					:value="v.docDate.$model"
					@change="v.docDate.$model = $event"
					:errorMessage="v.docDate"
					:max="new Date().toISOString()"
					@blur="v.docDate.$touch"
				/>
			</v-col>

			<v-col cols="6">
				<v-text-field
					v-model="v.issuer.$model"
					:errorMessages="getValidationErrorText(v.issuer)"
					label="Кем выдан"
					outlined
					@blur="v.issuer.$touch"
				/>
			</v-col>
			<v-col cols="3">
				<v-text-field
					v-model="v.series.$model"
					:errorMessages="getValidationErrorText(v.series)"
					label="Серия документа"
					outlined
					@blur="v.series.$touch"
				/>
			</v-col>
			<v-col cols="3">
				<v-text-field
					v-model="v.number.$model"
					:errorMessages="getValidationErrorText(v.number)"
					label="Номер документа"
					outlined
					@blur="v.number.$touch"
				/>
			</v-col>

			<v-col cols="12">
				<AttachDocumentSingle
					:load-profile-document-type="DocumentType.CONFIRMATION_OF_STATUS"
					:value="{
            file: v.file.$model,
            fileSig: v.fileSig.$model,
          }"
					:error-messages="getValidationErrorText(v.file)"
					@change="
            v.file.$model = $event.file;
            v.fileSig.$model = $event.fileSig;
          "
					@change-from-profile="
            v.name.$model = $event.name;
            v.docDate.$model = $event.docDate;
            v.issuer.$model = $event.issuer;
            v.series.$model = $event.series;
            v.number.$model = $event.number;
            v.file.$model = $event.file;
            v.fileSig.$model = $event.fileSig;
          "
					:document-types="documentTypes"
					:with-select="statementType === StatementType.NOTICE_RECOVERY && isNoticeRecoveryClassifierEnable"
					:has-description="statementType === StatementType.NOTICE_RECOVERY && isNoticeRecoveryClassifierEnable"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {mdiAlertCircleOutline} from '@mdi/js';
import {and, maxLength, requiredIf} from 'vuelidate/lib/validators';
import {DATE_FORMAT, DATE_FUTURE, DATE_PAST, EMOJI, TRAILING_AND_LEADING_SPACES} from '@/utils/validate';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import {getValidationErrorText} from '@/utils/validate';
import {DocumentType} from '@/types/services';
import {UploadDocumentTypes} from "@/utils/uploadDocumentTypes";
import {StatementType} from '@/constants';
import { isNoticeRecoveryClassifierEnable } from '@/app.config';

export const getStatusDocumentValidation = (trustee, isAssignee) => {
	const status = isAssignee ? trustee.status : trustee.trusteeStatus;

	return {
		name: {
			required: requiredIf(
				(vm) =>
					status ||
					vm.series ||
					vm.docDate ||
					vm.issuer ||
					vm.number ||
					vm.file ||
					vm.fileSig
			),
			maxLength: maxLength(1000),
			EMOJI,
			TRAILING_AND_LEADING_SPACES
		},
		docDate: {
			required: requiredIf(
				(vm) =>
					status ||
					vm.series ||
					vm.name ||
					vm.issuer ||
					vm.number ||
					vm.file ||
					vm.fileSig
			),
			DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
		},
		issuer: {
			required: requiredIf(
				(vm) =>
					status ||
					vm.series ||
					vm.name ||
					vm.docDate ||
					vm.number ||
					vm.file ||
					vm.fileSig
			),
			maxLength: maxLength(1000),
			EMOJI,
			TRAILING_AND_LEADING_SPACES
		},
		series: {
			maxLength: maxLength(25),
			EMOJI,
			TRAILING_AND_LEADING_SPACES
		},
		number: {
			required: requiredIf(
				(vm) =>
					status ||
					vm.series ||
					vm.name ||
					vm.issuer ||
					vm.docDate ||
					vm.file ||
					vm.fileSig
			),
			maxLength: maxLength(50),
			EMOJI,
			TRAILING_AND_LEADING_SPACES
		},
		file: {},
		fileSig: {},
	};
};

export const statusDocumentModel = {
	type: 'CONFIRMATION_OF_STATUS',
	name: '',
	docDate: '',
	issuer: '',
	series: '',
	number: '',
	file: null,
	fileSig: null,
};

export default {
	name: 'StatusDocument',
	props: {
		v: {
			type: Object,
			required: true,
		},
		statementType: {
			type: String,
			required: true,
		},
	},
	components: {
		AttachDocumentSingle,
		DateFieldCustom,
	},
	data: () => ({
		DocumentType,
		mdiAlertCircleOutline,
		getValidationErrorText,
		StatementType,
    isNoticeRecoveryClassifierEnable,
	}),
	computed: {
		documentTypes() {
			const docsCodes = ['12302']
			return UploadDocumentTypes
				.filter((item) => ['12300'].includes(item.groupCode))
				.map((item) => {
					return {
						...item,
						documents: item.documents.filter((doc => docsCodes.includes(doc.value)))
					}
				})
		}
	}
};
</script>
